/**
 * @generated SignedSource<<f20f3b75e9d2bbdef5f50b4d1151e3e9>>
 * @relayHash fbfaf1220b7f6011aa9a464a6026bcb3
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID fbfaf1220b7f6011aa9a464a6026bcb3

import { ConcreteRequest } from 'relay-runtime';
export type CareProviderGroupSearchType = "ADVANCE" | "INLINE";
export type CareProviderGroupType = "CHIROPRACTOR" | "DENTIST" | "DOCTOR" | "HOSPITAL" | "NONE" | "NUTRITIONIST" | "PHARMACY" | "PHYSIOTHERAPIST" | "PSYCHOTHERAPIST";
export type GroupLevel = "GROUP" | "NONE" | "SUBGROUP";
export type CareProviderGroupFilterInput = {
  and?: ReadonlyArray<CareProviderGroupFilterInput> | null;
  createdAt?: DateTimeOperationFilterInput | null;
  deletedAt?: DateTimeOperationFilterInput | null;
  displayId?: IntOperationFilterInput | null;
  groupLevel?: GroupLevelOperationFilterInput | null;
  groupName?: StringOperationFilterInput | null;
  groupType?: CareProviderGroupTypeOperationFilterInput | null;
  id?: IdOperationFilterInput | null;
  or?: ReadonlyArray<CareProviderGroupFilterInput> | null;
  parentId?: IdOperationFilterInput | null;
  searchTypes?: ListCareProviderGroupSearchTypeOperationFilterInput | null;
  validFrom?: DateOperationFilterInput | null;
  validTo?: DateOperationFilterInput | null;
};
export type DateTimeOperationFilterInput = {
  eq?: string | null;
  gt?: string | null;
  gte?: string | null;
  in?: ReadonlyArray<string | null> | null;
  lt?: string | null;
  lte?: string | null;
  neq?: string | null;
  ngt?: string | null;
  ngte?: string | null;
  nin?: ReadonlyArray<string | null> | null;
  nlt?: string | null;
  nlte?: string | null;
};
export type IntOperationFilterInput = {
  eq?: number | null;
  gt?: number | null;
  gte?: number | null;
  in?: ReadonlyArray<number | null> | null;
  lt?: number | null;
  lte?: number | null;
  neq?: number | null;
  ngt?: number | null;
  ngte?: number | null;
  nin?: ReadonlyArray<number | null> | null;
  nlt?: number | null;
  nlte?: number | null;
};
export type GroupLevelOperationFilterInput = {
  eq?: GroupLevel | null;
  in?: ReadonlyArray<GroupLevel> | null;
  neq?: GroupLevel | null;
  nin?: ReadonlyArray<GroupLevel> | null;
};
export type StringOperationFilterInput = {
  and?: ReadonlyArray<StringOperationFilterInput> | null;
  contains?: string | null;
  endsWith?: string | null;
  eq?: string | null;
  in?: ReadonlyArray<string | null> | null;
  ncontains?: string | null;
  nendsWith?: string | null;
  neq?: string | null;
  nin?: ReadonlyArray<string | null> | null;
  nstartsWith?: string | null;
  or?: ReadonlyArray<StringOperationFilterInput> | null;
  startsWith?: string | null;
};
export type CareProviderGroupTypeOperationFilterInput = {
  eq?: CareProviderGroupType | null;
  in?: ReadonlyArray<CareProviderGroupType> | null;
  neq?: CareProviderGroupType | null;
  nin?: ReadonlyArray<CareProviderGroupType> | null;
};
export type IdOperationFilterInput = {
  eq?: string | null;
  in?: ReadonlyArray<string | null> | null;
  neq?: string | null;
  nin?: ReadonlyArray<string | null> | null;
};
export type ListCareProviderGroupSearchTypeOperationFilterInput = {
  all?: CareProviderGroupSearchTypeOperationFilterInput | null;
  any?: boolean | null;
  none?: CareProviderGroupSearchTypeOperationFilterInput | null;
  some?: CareProviderGroupSearchTypeOperationFilterInput | null;
};
export type CareProviderGroupSearchTypeOperationFilterInput = {
  eq?: CareProviderGroupSearchType | null;
  in?: ReadonlyArray<CareProviderGroupSearchType> | null;
  neq?: CareProviderGroupSearchType | null;
  nin?: ReadonlyArray<CareProviderGroupSearchType> | null;
};
export type DateOperationFilterInput = {
  eq?: any | null;
  gt?: any | null;
  gte?: any | null;
  in?: ReadonlyArray<any | null> | null;
  lt?: any | null;
  lte?: any | null;
  neq?: any | null;
  ngt?: any | null;
  ngte?: any | null;
  nin?: ReadonlyArray<any | null> | null;
  nlt?: any | null;
  nlte?: any | null;
};
export type useAdvancedCareProviderSearchFiltersQuery$variables = {
  where: CareProviderGroupFilterInput;
};
export type useAdvancedCareProviderSearchFiltersQuery$data = {
  readonly cantons: ReadonlyArray<{
    readonly cantonCode: string;
    readonly id: string;
    readonly translations: ReadonlyArray<{
      readonly language: string;
      readonly name: string;
    }>;
  }>;
  readonly careProviderGroups: {
    readonly items: ReadonlyArray<{
      readonly groupType: CareProviderGroupType;
      readonly id: string;
      readonly services: ReadonlyArray<{
        readonly id: string;
        readonly translations: ReadonlyArray<{
          readonly language: string;
          readonly name: string;
        }>;
      }>;
      readonly specialties: ReadonlyArray<{
        readonly foci: ReadonlyArray<{
          readonly id: string;
          readonly translations: ReadonlyArray<{
            readonly language: string;
            readonly name: string;
          }>;
        }>;
        readonly id: string;
        readonly specializations: ReadonlyArray<{
          readonly id: string;
          readonly translations: ReadonlyArray<{
            readonly language: string;
            readonly name: string;
          }>;
        }>;
        readonly translations: ReadonlyArray<{
          readonly language: string;
          readonly name: string;
        }>;
      }>;
      readonly subjectAreas: ReadonlyArray<{
        readonly id: string;
        readonly translations: ReadonlyArray<{
          readonly language: string;
          readonly name: string;
        }>;
      }>;
      readonly translations: ReadonlyArray<{
        readonly language: string;
        readonly name: string;
      }>;
    }> | null;
  } | null;
  readonly certificates: ReadonlyArray<{
    readonly id: string;
    readonly translations: ReadonlyArray<{
      readonly language: string;
      readonly name: string;
    }>;
  }>;
  readonly diagnosticFacilities: ReadonlyArray<{
    readonly id: string;
    readonly translations: ReadonlyArray<{
      readonly language: string;
      readonly name: string;
    }>;
  }>;
  readonly officialLanguages: ReadonlyArray<{
    readonly id: string;
    readonly isoLanguageCode: string;
    readonly officialLanguageLookupId: number;
    readonly translations: ReadonlyArray<{
      readonly language: string;
      readonly name: string;
    }>;
  }>;
};
export type useAdvancedCareProviderSearchFiltersQuery = {
  response: useAdvancedCareProviderSearchFiltersQuery$data;
  variables: useAdvancedCareProviderSearchFiltersQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "where"
  }
],
v1 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  },
  {
    "kind": "Variable",
    "name": "where",
    "variableName": "where"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "groupType",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "language",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v6 = [
  (v4/*:: as any*/),
  (v5/*:: as any*/)
],
v7 = {
  "alias": "translations",
  "args": null,
  "concreteType": "CareProviderGroupTranslation",
  "kind": "LinkedField",
  "name": "careProviderGroupTranslations",
  "plural": true,
  "selections": (v6/*:: as any*/),
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cantonCode",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isoLanguageCode",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "officialLanguageLookupId",
  "storageKey": null
},
v11 = {
  "alias": "name",
  "args": null,
  "kind": "ScalarField",
  "name": "isoLanguageName",
  "storageKey": null
},
v12 = [
  (v4/*:: as any*/),
  (v5/*:: as any*/),
  (v2/*:: as any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useAdvancedCareProviderSearchFiltersQuery",
    "selections": [
      {
        "alias": "careProviderGroups",
        "args": (v1/*:: as any*/),
        "concreteType": "CareProviderGroupConnection",
        "kind": "LinkedField",
        "name": "ch_careProviderGroups",
        "plural": false,
        "selections": [
          {
            "alias": "items",
            "args": null,
            "concreteType": "CareProviderGroup",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v7/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Specialty",
                "kind": "LinkedField",
                "name": "specialties",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "alias": "translations",
                    "args": null,
                    "concreteType": "SpecialtyTranslation",
                    "kind": "LinkedField",
                    "name": "specialtyTranslations",
                    "plural": true,
                    "selections": (v6/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Focus",
                    "kind": "LinkedField",
                    "name": "foci",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": "translations",
                        "args": null,
                        "concreteType": "FocusTranslation",
                        "kind": "LinkedField",
                        "name": "focusTranslations",
                        "plural": true,
                        "selections": (v6/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Specialization",
                    "kind": "LinkedField",
                    "name": "specializations",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": "translations",
                        "args": null,
                        "concreteType": "SpecializationTranslation",
                        "kind": "LinkedField",
                        "name": "specializationTranslations",
                        "plural": true,
                        "selections": (v6/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SubjectArea",
                "kind": "LinkedField",
                "name": "subjectAreas",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "alias": "translations",
                    "args": null,
                    "concreteType": "SubjectAreaTranslation",
                    "kind": "LinkedField",
                    "name": "subjectAreaTranslations",
                    "plural": true,
                    "selections": (v6/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Services",
                "kind": "LinkedField",
                "name": "services",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "alias": "translations",
                    "args": null,
                    "concreteType": "ServicesTranslation",
                    "kind": "LinkedField",
                    "name": "servicesTranslations",
                    "plural": true,
                    "selections": (v6/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "cantons",
        "args": null,
        "concreteType": "Canton",
        "kind": "LinkedField",
        "name": "ch_cantons",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          (v8/*:: as any*/),
          {
            "alias": "translations",
            "args": null,
            "concreteType": "CantonTranslation",
            "kind": "LinkedField",
            "name": "cantonTranslations",
            "plural": true,
            "selections": (v6/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "officialLanguages",
        "args": null,
        "concreteType": "OfficialLanguageLookup",
        "kind": "LinkedField",
        "name": "ch_officialLanguagesLookup",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          {
            "alias": "translations",
            "args": null,
            "concreteType": "OfficialLanguageLookupTranslation",
            "kind": "LinkedField",
            "name": "officialLanguageLookupTranslations",
            "plural": true,
            "selections": [
              (v11/*:: as any*/),
              (v4/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "diagnosticFacilities",
        "args": null,
        "concreteType": "DiagnosticFacilities",
        "kind": "LinkedField",
        "name": "ch_diagnosticFacilities",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": "translations",
            "args": null,
            "concreteType": "DiagnosticFacilitiesTranslation",
            "kind": "LinkedField",
            "name": "diagnosticFacilitiesTranslations",
            "plural": true,
            "selections": (v6/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "certificates",
        "args": null,
        "concreteType": "Certificates",
        "kind": "LinkedField",
        "name": "ch_certificates",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": "translations",
            "args": null,
            "concreteType": "CertificateTranslation",
            "kind": "LinkedField",
            "name": "certificateTranslations",
            "plural": true,
            "selections": (v6/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useAdvancedCareProviderSearchFiltersQuery",
    "selections": [
      {
        "alias": "careProviderGroups",
        "args": (v1/*:: as any*/),
        "concreteType": "CareProviderGroupConnection",
        "kind": "LinkedField",
        "name": "ch_careProviderGroups",
        "plural": false,
        "selections": [
          {
            "alias": "items",
            "args": null,
            "concreteType": "CareProviderGroup",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*:: as any*/),
              (v3/*:: as any*/),
              (v7/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Specialty",
                "kind": "LinkedField",
                "name": "specialties",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "alias": "translations",
                    "args": null,
                    "concreteType": "SpecialtyTranslation",
                    "kind": "LinkedField",
                    "name": "specialtyTranslations",
                    "plural": true,
                    "selections": (v12/*:: as any*/),
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Focus",
                    "kind": "LinkedField",
                    "name": "foci",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": "translations",
                        "args": null,
                        "concreteType": "FocusTranslation",
                        "kind": "LinkedField",
                        "name": "focusTranslations",
                        "plural": true,
                        "selections": (v12/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Specialization",
                    "kind": "LinkedField",
                    "name": "specializations",
                    "plural": true,
                    "selections": [
                      (v2/*:: as any*/),
                      {
                        "alias": "translations",
                        "args": null,
                        "concreteType": "SpecializationTranslation",
                        "kind": "LinkedField",
                        "name": "specializationTranslations",
                        "plural": true,
                        "selections": (v12/*:: as any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "SubjectArea",
                "kind": "LinkedField",
                "name": "subjectAreas",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "alias": "translations",
                    "args": null,
                    "concreteType": "SubjectAreaTranslation",
                    "kind": "LinkedField",
                    "name": "subjectAreaTranslations",
                    "plural": true,
                    "selections": (v12/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Services",
                "kind": "LinkedField",
                "name": "services",
                "plural": true,
                "selections": [
                  (v2/*:: as any*/),
                  {
                    "alias": "translations",
                    "args": null,
                    "concreteType": "ServicesTranslation",
                    "kind": "LinkedField",
                    "name": "servicesTranslations",
                    "plural": true,
                    "selections": (v12/*:: as any*/),
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "cantons",
        "args": null,
        "concreteType": "Canton",
        "kind": "LinkedField",
        "name": "ch_cantons",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          (v8/*:: as any*/),
          {
            "alias": "translations",
            "args": null,
            "concreteType": "CantonTranslation",
            "kind": "LinkedField",
            "name": "cantonTranslations",
            "plural": true,
            "selections": (v12/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "officialLanguages",
        "args": null,
        "concreteType": "OfficialLanguageLookup",
        "kind": "LinkedField",
        "name": "ch_officialLanguagesLookup",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          (v9/*:: as any*/),
          (v10/*:: as any*/),
          {
            "alias": "translations",
            "args": null,
            "concreteType": "OfficialLanguageLookupTranslation",
            "kind": "LinkedField",
            "name": "officialLanguageLookupTranslations",
            "plural": true,
            "selections": [
              (v11/*:: as any*/),
              (v4/*:: as any*/),
              (v2/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "diagnosticFacilities",
        "args": null,
        "concreteType": "DiagnosticFacilities",
        "kind": "LinkedField",
        "name": "ch_diagnosticFacilities",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": "translations",
            "args": null,
            "concreteType": "DiagnosticFacilitiesTranslation",
            "kind": "LinkedField",
            "name": "diagnosticFacilitiesTranslations",
            "plural": true,
            "selections": (v12/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": "certificates",
        "args": null,
        "concreteType": "Certificates",
        "kind": "LinkedField",
        "name": "ch_certificates",
        "plural": true,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": "translations",
            "args": null,
            "concreteType": "CertificateTranslation",
            "kind": "LinkedField",
            "name": "certificateTranslations",
            "plural": true,
            "selections": (v12/*:: as any*/),
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "fbfaf1220b7f6011aa9a464a6026bcb3",
    "metadata": {},
    "name": "useAdvancedCareProviderSearchFiltersQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d4b37ce93a79444f6ed953f2eb7eba30";

export default node;
